import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../../axios/axiosBaseQuery';
import { NotificationAPIResponse } from './Notification.model';
import Util from '../../../util/Util';

const NotificationBaseURL = new Util().getUserNotificationServiceURL();
const NotificationAPI = createApi({
  reducerPath: 'notification',
  baseQuery: axiosBaseQuery({ baseUrl: NotificationBaseURL }),
  tagTypes: ['notifications-action'],
  endpoints(build) {
    return {
      getUnreadNotifications: build.query<NotificationAPIResponse[], any>({
        query: () => ({
          url: '/unread',
        }),
        providesTags: ['notifications-action'],
      }),
      getNotifications: build.query<NotificationAPIResponse[], void>({
        query: () => ({
          url: '',
        }),
        providesTags: ['notifications-action'],
      }),
      setNotificationReadStatus: build.mutation<
        any,
        { timestamp: number; status: boolean }
      >({
        query: ({ timestamp, status }) => ({
          url: `/${timestamp}?read=${status}`,
          method: 'PUT',
        }),
        invalidatesTags: ['notifications-action'],
      }),
      setAllNotificationReadStatus: build.mutation<any, { status: boolean }>({
        query: ({ status = true }) => ({
          url: `/all?read=${status}`,
          method: 'PUT',
        }),
        invalidatesTags: ['notifications-action'],
      }),
    };
  },
});

export default NotificationAPI;
